export default async ({ $gtm }, inject) => {
  if (process.server) { return }

  const { UserAgentApplication } = await import('msal')

  const authority = localStorage.getItem('last_used_authority') || process.env.B2C_AUTHORITY

  const msalInstance = new UserAgentApplication({
    auth: {
      clientId: process.env.B2C_CLIENT_ID,
      authority,
      navigateToLoginRequestUrl: false,
      postLogoutRedirectUri: process.env.APP_URL,
      validateAuthority: false,
      redirectUri: process.env.APP_URL + '/auth/callback'
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: true
    },
    system: {
      loadFrameTimeout: 90000
    }
  })

  const account = msalInstance.getAccount()
  if (account) {
    try {
      const response = await msalInstance.acquireTokenSilent({
        scopes: [`https://bakerbookhouse.onmicrosoft.com/${process.env.B2C_ENV}-bbh-ecomm-api/user_impersonate`]
      })

      const email = response.idTokenClaims?.emails?.[0]
      if (email && $gtm) {
        $gtm.push({
          event: 'userLoggedIn',
          userEmail: email
        })
      }
    } catch (error) {
      // Token silent failure (probably session expired)
      console.log('MSAL silent token acquisition failed, no valid session.')
    }
  }
}
